import { Injectable } from '@angular/core';
import { SimulationResult } from '@app/dao/simulation/simulation.interface';
import { BsModalService } from 'ngx-bootstrap/modal';
import { defer, Observable, tap } from 'rxjs';
import { SimulationOwnerModalComponent } from './simulation-owner-modal.component';

@Injectable({
  providedIn: 'root',
})
export class SimulationOwnerChoiceService {
  constructor(private modalService: BsModalService) {}

  /**
   * Ouvre la modale d'attribution sur le dernier choix de la simulation : émet les propriétaires choisis,
   * mémorisés sur la simulation, puis se termine ; se termine sans rien émettre si la modale est fermée
   * sans choix.
   */
  choose(simulation: SimulationResult<any, any>): Observable<number[]> {
    return defer(
      () =>
        this.modalService.show(SimulationOwnerModalComponent, {
          class: 'ea-modal-plan',
          initialState: { rememberedOwnerIds: simulation.ownerIds },
        }).content.choice,
    ).pipe(tap(ownerIds => (simulation.ownerIds = ownerIds)));
  }
}
